import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserHasCommunity, UserItemMinimal } from '../../../api/models';
import { enumUserRole } from '../../utils/enum-user-role';
import { LazyLoadEvent } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { FormControl, FormGroup } from '@angular/forms';
import { CommunityService } from '../../../api/services';
import { CommunityControllerGetMembers$Params } from '../../../api/fn/community/community-controller-get-members';

@Component({
  selector: 'app-modal-community-users',
  templateUrl: './modal-community-users.component.html',
  styleUrl: './modal-community-users.component.scss'
})
export class ModalCommunityUsersComponent {

  travelers: UserItemMinimal[] = [];
  enumUserRole = enumUserRole;
  community_id?: number;
  totalRecords = 0;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private router: Router,
    private communityService: CommunityService
  ){
    if (config.data!.id) {
      this.community_id = config.data.id;
    }
   }

  ngOnInit(){
    this.router.events.subscribe({
      next: () => {
        this.ref.close();
      }
    })
  }

  getTravelers(event: TableLazyLoadEvent){
    const params: CommunityControllerGetMembers$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      id: this.community_id!,
    }
    if (event.globalFilter != null) {
      if (event.globalFilter[0] != '') {
        params.query = event.globalFilter[0];
      }
    }
    this.communityService.communityControllerGetMembers(params).subscribe({
      next: (res) => {
        this.travelers = res.data.list;
        this.totalRecords = res.data.count;
      }
    })
  }

}
